<div class="dialog-form">
    <form [formGroup]="servicePackageOrderForm" (ngSubmit)="save()">
        <p-fieldset class="basic">
            <p-header class="article-title">
                <span class="article-title">Dados da Contratação</span>
            </p-header>

            <div class="form-group">
                <div class="form-control">
                    <label for="packageService">{{ 'SERVICE-PACKAGE' | translate }} *</label>
                    <p-dropdown
                        [placeholder]="'SELECT-PACKAGE' | translate"
                        [filter]="true"
                        [options]="packageServiceOptions"
                        formControlName="packageService"
                        optionLabel="label"
                        optionValue="value"
                        [showClear]="true"
                        appendTo="body">
                    </p-dropdown>
                </div>

                <div class="form-control">
                    <label for="boat">{{ 'VESSEL' | translate }} *</label>
                    <p-dropdown
                        [placeholder]="'SELECT-VESSEL' | translate"
                        [filter]="true"
                        [options]="boatOptions"
                        formControlName="boat"
                        optionLabel="label"
                        optionValue="value"
                        [showClear]="true"
                        appendTo="body">
                    </p-dropdown>
                </div>
            </div>

            <div class="form-group">
                <div class="form-control">
                    <label for="customer">{{ 'CUSTOMER' | translate }} *</label>
                    <p-dropdown
                        [placeholder]="'SELECT-CUSTOMER' | translate"
                        [filter]="true"
                        [options]="customerOptions"
                        formControlName="customer"
                        optionLabel="label"
                        optionValue="value"
                        [showClear]="true"
                        appendTo="body"
                        [disabled]="!servicePackageOrderForm.get('boat')?.value">
                    </p-dropdown>
                </div>
            </div>

            <div class="form-group">
                <div class="form-control">
                    <label for="validityStartDate">{{ 'VALIDITY-START' | translate }} *</label>
                    <p-calendar
                        formControlName="validityStartDate"
                        placeholder="dd/mm/aaaa"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        appendTo="body">
                    </p-calendar>
                </div>

                <div class="form-control">
                    <label for="validityEndDate">{{ 'VALIDITY-END' | translate }} *</label>
                    <p-calendar
                        formControlName="validityEndDate"
                        placeholder="dd/mm/aaaa"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        appendTo="body">
                    </p-calendar>
                </div>
            </div>

            <div class="form-group">
                <div class="form-control">
                    <label for="value">{{ 'VALUE' | translate }} (R$) *</label>
                    <div class="readonly-field" *ngIf="!isValueEditable()">
                        <span *ngIf="getPackageValue(); else emptyValue">{{ getPackageValue() }}</span>
                        <ng-template #emptyValue>
                            <span class="text-muted">Selecione pacote e embarcação</span>
                        </ng-template>
                    </div>
                    <p-inputNumber
                        *ngIf="isValueEditable()"
                        formControlName="value"
                        mode="decimal"
                        [minFractionDigits]="2"
                        [maxFractionDigits]="2"
                        [min]="0"
                        placeholder="0,00">
                    </p-inputNumber>
                </div>

                <div class="form-control">
                    <label for="discount">{{ 'DISCOUNT' | translate }} (R$)</label>
                    <input
                        pInputText
                        type="number"
                        formControlName="discount"
                        placeholder="0.00"
                        step="0.01"
                        min="0">
                </div>
            </div>

            <div class="form-group single-field">
                <div class="form-control" style="max-width: unset;">
                    <label for="observations">{{ 'OBSERVATIONS' | translate }}</label>
                    <textarea
                        pInputText
                        formControlName="observations"
                        [placeholder]="'ADDITIONAL-DETAILS' | translate"
                        rows="4"
                        maxlength="500">
                    </textarea>
                    <span class="hint">{{servicePackageOrderForm.get('observations')?.value?.length || 0}} / 500</span>
                </div>
            </div>
        </p-fieldset>

        <div class="form-group align-center">
            <div class="form-control">
                {{'REQUIRED-FIELDS' | translate}}
            </div>
            <div class="buttons">
                <button class="easymarine danger" type="button" (click)="cancel()">
                    {{ 'CANCEL' | translate }}
                </button>
                <button class="easymarine primary" type="submit" [disabled]="loading || servicePackageOrderForm.invalid">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    {{ 'SAVE-ORDER' | translate }}
                </button>
            </div>
        </div>
    </form>
</div>
